<template>
  <div class="borderSelector">

    <div class="group">
      <label>Taille (px)</label>
      <input type="number" v-model="size" min="0">
    </div>

    <div class="group">
      <label>Style</label>
      <select v-model="style">
        <option value="" disabled hidden>Choisir un style...</option>
        <option value="solid">Solide</option>
        <option value="dashed">Hachurée</option>
        <option value="dotted">Pointillée</option>
        <option value="double">Doublée</option>
      </select>
    </div>

    <div class="group">
      <label>Couleur</label>
      <ColorSelector :colors="colors" :value="color" @changed="color = $event"
                     placeholder="Choisir une couleur"></ColorSelector>
    </div>

  </div>
</template>

<script>
  import ColorSelector from "./ColorSelector.vue";

  export default {
    name: "borderSelector",

    components: { ColorSelector },

    props: {
      value: String,
      colors: Array
    },

    data() {
      return {
        size: null,
        style: "",
        color: ""
      }
    },

    watch: {
      $data: {
        handler: function() {
          this.submitChange();
        },
        deep: true
      }
    },

    mounted() {
      this.initBorder();
    },

    methods: {
      initBorder() {
        if (this.value) {
          this.size = parseInt(this.value.split(" ")[0].replace("px",""));
          this.style = this.value.split(" ")[1];
          this.color = this.value.split(" ")[2] ;
        }
      },
      submitChange() {
        if (this.size) {
          this.$emit("changed", this.size + "px " + this.style + " " + this.color);
        } else {
          this.$emit("changed", "");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .borderSelector {
    display: flex;
    width: 100%;
    padding-top: 6px;

    .group {
      flex-grow: 1;
      &:not(:last-child) {
        padding-right: 10px;
      }
    }
  }
</style>